// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows: SRP (deep-link URL only), SoC, Modular Architecture.
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

/**
 * Absolute URL for authenticated users to open Voice Process with a task modal.
 * Requires sign-in and team access; not a public one-time share token.
 *
 * Uses VITE_FRONTEND_URL when set (see front-end/env.example); else window.location.origin.
 */

export function buildVoiceProcessTaskDeepLink(taskId) {
  if (taskId == null || String(taskId).trim() === '') {
    return '';
  }
  const origin = (
    import.meta.env.VITE_FRONTEND_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '') ||
    ''
  ).replace(/\/$/, '');
  const id = encodeURIComponent(String(taskId).trim());
  return `${origin}/voice-process?task=${id}`;
}

/** UUID v4 pattern for validating ?task= query (avoid junk opens). */
export function isLikelyVoiceTaskId(value) {
  if (value == null || typeof value !== 'string') return false;
  const v = value.trim();
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(v);
}
